import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CloudConnectedIcon: FC<IconProps> = (props) => {
  return (
    <svg {...initializeSvgIconProps(props)}>
      <g clipPath="url(#clip0_1950_61000)">
        <path
          d="M15.2441 9.17383C15.2441 7.83874 14.5561 7.1146 13.8457 6.7002C13.4829 6.48858 13.1154 6.36022 12.8359 6.28516C12.6971 6.24788 12.5819 6.22486 12.5039 6.21094C12.4652 6.20403 12.4357 6.19993 12.417 6.19727C12.4077 6.19595 12.4012 6.1948 12.3975 6.19434L12.3955 6.19336V6.19434C12.1938 6.17193 12.0255 6.02909 11.9697 5.83398C11.8084 5.2694 11.4893 4.67891 10.9434 4.23047C10.4031 3.78684 9.60446 3.45215 8.4248 3.45215C7.09242 3.45217 6.31621 3.9023 5.82324 4.45215C5.31 5.02463 5.0602 5.75177 4.87988 6.38281C4.81857 6.5974 4.62257 6.74601 4.39941 6.74609C4.11379 6.74609 3.38496 6.8636 2.74316 7.26465C2.12897 7.64852 1.60554 8.27918 1.60547 9.35645C1.60547 10.262 2.0174 10.7951 2.55664 11.126C3.12447 11.4744 3.84816 11.6016 4.39941 11.6016H12.4502C13.1107 11.6016 13.8231 11.434 14.3555 11.0537C14.8648 10.6899 15.2441 10.1099 15.2441 9.17383ZM16.2441 9.17383C16.2441 10.4334 15.709 11.317 14.9375 11.8682C14.189 12.4028 13.2535 12.6016 12.4502 12.6016H4.39941C3.73077 12.6016 2.80726 12.4535 2.0332 11.9785C1.23063 11.486 0.605469 10.6466 0.605469 9.35645C0.605542 7.87226 1.36334 6.94802 2.21289 6.41699C2.84507 6.02188 3.53398 5.83739 4.02148 5.77344C4.21362 5.16537 4.51288 4.41677 5.0791 3.78516C5.77551 3.00839 6.82954 2.45217 8.4248 2.45215C9.8066 2.45215 10.8375 2.84969 11.5781 3.45801C12.2101 3.97714 12.6039 4.62821 12.832 5.25586C12.9091 5.27231 12.9973 5.29415 13.0947 5.32031C13.4328 5.41108 13.8891 5.56827 14.3496 5.83691C15.286 6.3832 16.2441 7.39826 16.2441 9.17383Z"
          fill="currentColor"
        />
        <path
          d="M8.47878 10.0876C8.39044 10.2009 8.25762 10.271 8.11418 10.2796C7.97082 10.2881 7.83069 10.2344 7.72955 10.1325L6.26354 8.65407C6.06918 8.45795 6.0709 8.14066 6.267 7.94627C6.46313 7.75214 6.77979 7.75439 6.9741 7.95041L8.04029 9.02488L9.9144 6.61906C10.0841 6.40125 10.3982 6.36232 10.616 6.53205C10.8337 6.70181 10.8727 7.01586 10.703 7.23364L8.47878 10.0876Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1950_61000">
          <rect fill="white" height="16" transform="translate(0.424805 0.452148)" width="16" />
        </clipPath>
      </defs>
      {/* <path
        d="M 15.375977 14.277344 L 15.859375 14.277344 C 17.143555 14.277344 18.427734 13.134766 18.427734 11.992188 C 18.427734 9.990234 17.001953 9.418945 15.859375 9.418945 C 16.049805 8.515625 16.000977 6.59668 13.999023 5.419922 C 11.68457 4.057617 9.287109 5.419922 8.569336 6.850586 C 7.998047 6.542969 6.713867 6.132812 5.429688 6.992188 C 4.140625 7.84668 4.140625 9.135742 4.140625 9.707031 C 2.998047 9.707031 1.430664 10.136719 1.430664 12.133789 C 1.430664 13.564453 2.856445 14.277344 4.140625 14.277344 L 5 14.277344 "
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeWidth="1.25"
        transform="matrix(0.8,0,0,0.8,0,0)"
      />
      <path
        d="M 8.125 13.500977 L 10 15.375977 L 13.125 11.625977 "
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeWidth="1.25"
        transform="matrix(0.8,0,0,0.8,0,0)"
      /> */}
    </svg>
  );
};
